import Card from 'components/Card/Card';
import TabularList from 'components/TabularList/TabularList';
import UploadFile from 'components/UploadFile/UploadFile';
import { PROVIDER_FILE_TYPES } from 'services/providers.service';

const SchoolLetter = ({ careFacility, careFacilityFiles, setCareFacilityFiles, isEditable = true }) => {
  return (
    <Card title="School-based care letter" stickyHeader noBodyPadding>
      <TabularList
        indented
        data={[
          {
            title: 'School letter',
            titleRequired: true,
            value: (
              <UploadFile
                fileCode={PROVIDER_FILE_TYPES.STATE_LICENSE.code}
                files={careFacilityFiles}
                setFiles={setCareFacilityFiles}
                careFacilityId={careFacility?.id}
                preventDeleteIfLastFile
                readOnly={!isEditable}
              />
            ),
          },
        ]}
      />
    </Card>
  );
};

export { SchoolLetter };
